import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { ResourceList, ResourceItem } from '@shopify/polaris';

import { renderAccessorValue } from '@utils/index';

const propTypes = {
  items: PropTypes.array.isRequired,
  itemURL: PropTypes.string,
  urlAction: PropTypes.string,

  columnsInfo: PropTypes.array.isRequired,
  conditionalRowClass: PropTypes.func,

  selectedItems: PropTypes.array,
  onSelectionChange: PropTypes.func,
  bulkActions: PropTypes.array,

  renderItemExtra: PropTypes.func, // Render a component after the ResourceItem, it appears when the item is expanded
};

const defaultProps = {
  selectedItems: [],
}


const ResourceTableBody = (props) => {
  const [expandedItemIds, setExpandedItemIds] = useState([]); // Only relevant if renderItemExtra is defined

  const handleItemPress = (itemId) => {
    if(!!props.renderItemExtra){
      const expandedItems = expandedItemIds.includes(itemId) ? expandedItemIds.filter(id => id !== itemId) : [...expandedItemIds, itemId];
      setExpandedItemIds(expandedItems);
    }
  }

  return(
    <div className="polaris-resource-table-body">
      <ResourceList
        items={ props.items }
        selectedItems={ props.selectedItems }
        onSelectionChange={ props.onSelectionChange }
        bulkActions={ props.bulkActions }
        loading={ props.loading }
        email_sent={props.email_sent}
        delivery_task_id={props.delivery_task_id} //remind me
        renderItem={(item) => {
          let itemURL = null;
          if(props.itemURL){
            itemURL = `${props.itemURL}/${item.id}${ !!props.urlAction ? ("/"+props.urlAction) : "" }`
          }
          let rowClass = "";
          if(!!props.conditionalRowClass){
            rowClass = props.conditionalRowClass(item);
          }

          const expandedContent = expandedItemIds.includes(item.id);

          return(
            <ResourceItem
              id={ item.id }
              url={ itemURL }
              onClick={ handleItemPress }
            >
              <div className="container-fluid p0">
                <div className={ `row ${rowClass}` }>
                  { props.columnsInfo.map( (col, index) => 
                    <div key={index} className={ `col-12 col-md-${ col.size } flex alignItemsCenter`}>
                      { renderAccessorValue(item, col, { expandedContent: expandedContent }) }
                    </div>
                  )}
                </div>
              </div>

              { !!props.renderItemExtra &&  
                <div>
                  { expandedContent && props.renderItemExtra(item) }
                </div>
              }
            </ResourceItem>
          )
        }}
      />
    </div>
  )
}

ResourceTableBody.propTypes = propTypes;
ResourceTableBody.defaultProps = defaultProps;

export default ResourceTableBody;